"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuditProgramResultsController = function AuditProgramResultsController($rootScope, $scope, DTOptionsBuilder, DTColumnBuilder, USER, CONST, materialButtons, datePicker, Constants, EpisodeDrgAuditTypeService, FunctionService) {
  _classCallCheck(this, AuditProgramResultsController);

  this.datatableApi;
  this.user = USER;
  this.name = "Audit Program Results";
  this.locale = "en-au";
  this.url = WEBSERVICEURL + "/dataagility/api/service.auditprogramresults";
  this.initUrl = this.url + "?startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
  this.separationString = "";

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
  });

  materialButtons.render();

  materialButtons.processing();

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  $scope.drawCallback = function (nRow) {
    // tell DataTables to sort month names in month order rather than alphabetically
    $.fn.dataTable.moment("MMMM");
  };

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    url: $scope.vm.initUrl,
    type: "GET"
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withOption("rowCallback", function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($("#auditTable").DataTable());
  }).withPaginationType("simple_numbers").withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto")
  // Sorting by this empty column allows the report to be sorted by date (retaining FY order) by default
  .withOption("aaSorting", [[1, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print",
    text: ""
  }, {
    extend: "csvHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "",
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]);

  this.dtColumns = [DTColumnBuilder.newColumn("dischargeMonth").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"),
  // This blank column is to allow manual data entry once exported to Excel
  DTColumnBuilder.newColumn("").withTitle("Episodes").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("episodesAudited").withTitle("Episodes<br>Audited").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("coderErrors").withTitle("Coder<br>Errors").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditorQueries").withTitle("Auditor<br>Queries").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("coderErrorsAuditorQueries").withTitle("Coder Errors and<br>Auditor Queries").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("otherChanges").withTitle("Other<br>Changes").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalChanges").withTitle("Total<br>Changes").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];

  function setDtHeaders(table) {
    $(table.column(0).header()).html($scope.vm.separationString + "<br>Month");
  }

  // Search filters
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];
  this.auditType = {
    selectedAuditType: []
  };
  this.auditTypeOptions = [];

  Constants.campusData().then(function successCallback(response) {
    $scope.vm.campusOptions = response;
    filterCampus($scope.vm.campusOptions);
  });

  EpisodeDrgAuditTypeService.types().then(function successCallback(response) {
    $scope.vm.auditTypeOptionsWithIds = response;
    angular.forEach(response, function (value, key) {
      if ($scope.vm.auditTypeOptions.indexOf(value.name) === -1) $scope.vm.auditTypeOptions.push(value.name);
    });
  });

  this.startDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
    }
  };
  this.endDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "days"),
      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
    }
  };

  // callbacks for lx-selects and lx-date-picker
  datePicker.autoClose($scope);
  this.filterCallback = filterCallback;

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  function filterAuditType(swap) {
    $scope.vm.auditType.selectedAuditType = [];
    if (swap === "add") {
      $scope.vm.auditType.selectedAuditType = $scope.vm.auditTypeOptions;
    }
  }

  function filterCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  function checkParam(param) {
    if (param && param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  this.changeData = changeData;

  function changeData() {
    var campus;
    if ($scope.vm.functionSettings && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
        campus = $scope.vm.user.campus;
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
    } else {
      campus = $scope.vm.campus.selectedCampus;
    }
    var newUrl = $scope.vm.url + "?startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&campus=" + checkParam(campus) + "&auditType=" + checkParam($scope.vm.auditType.selectedAuditType);
    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
  }

  function search() {
    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    var clearAuditTable = auditTable.search("").draw();

    filterCampus("minus");
    filterAuditType("minus");

    // re-draw tabele on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      $scope.vm.changeData();
    });
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {
    switch (thisFilter) {
      case "campus":
        if (thisModifier === "add") {
          filterCampus("add");
        } else {
          filterCampus("minus");
        }

        break;

      case "auditType":
        if (thisModifier === "add") {
          filterAuditType("add");
        } else {
          filterAuditType("minus");
        }

        break;

      default:
        break;
    }
  }
};

exports.default = AuditProgramResultsController;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramresults/auditprogramresults.controller.js